export * from './WidgetTable.style';
//# sourceMappingURL=index.js.map